export type FaqItem = {
  question: string;
  answer: string;
};

export type FaqCategory = {
  id: string;
  title: string;
  items: FaqItem[];
};

export const FAQ_SUPPORT_URL = 'https://support.paziresh24.com/';

export const faqIntro =
  'از زمان آغاز بکار پذیرش۲۴ تا امروز، سوالات متعددی از خدمات این واسط هوشمند بین پزشک و بیمار، برای کاربران پیش آمده و برآمدیم تا با جمع‌آوری سوالات پرتکرار، علاوه بر صرفه‌جویی در زمان کاربران، مراجعان به سهولت پاسخ سوالات خود را دریافت کنند.';

export const faqCategories: FaqCategory[] = [
  {
    id: 'in-person',
    title: 'راهنمای دریافت نوبت حضوری',
    items: [
      {
        question: 'چگونه در پذیرش۲۴، از پزشک مورد نظر، نوبت حضوری دریافت کنم؟',
        answer:
          'با مطالعه راهنمای دریافت نوبت در وب‌سایت پذیرش۲۴، نحوه دریافت نوبت حضوری به‌صورت گام‌به‌گام آموزش داده شده است.',
      },
      {
        question: 'آیا نوبت من در پذیرش۲۴ واقعا ثبت می‌شود؟',
        answer:
          'بله. در پایان مرحله نوبت‌دهی، یک کد رهگیری به شما تخصیص می‌یابد که نشانه روند صحیح شما در دریافت نوبت از پزشک مورد نظر می‌باشد.',
      },
      {
        question: 'ثبت نوبت در پذیرش24 همراه با پرداخت هزینه است؟',
        answer: 'سامانه پذیرش24 در قبال فرآیند نوبت‌دهی هیچ‌گونه هزینه‌ای دریافت نمی‌کند و این امر رایگان می‌باشد.',
      },
      {
        question: 'چگونه نوبت دریافتی را لغو کنیم؟',
        answer:
          'از بخش «نوبت‌های من» در پنل کاربری خود (اپلیکیشن یا وب‌سایت) می‌توانید نوبت ثبت‌شده را لغو کنید. توجه داشته باشید زمانی می‌توان نوبت آنلاین را لغو نمود که زمان ویزیت آنلاین فرا نرسیده باشد. در غیر این صورت در هنگام گفت‌وگو با پزشک امکان لغو ویزیت آنلاین امکان‌پذیر نیست.',
      },
      {
        question: 'آیا از طریق پذیرش ۲۴ به تمام مراکز درمانی و پزشکان در سراسر کشور دسترسی داریم؟',
        answer:
          'با توجه به مناطق تحت پوشش پذیرش24، مراجعان می‌توانند در ۳۱ استان و از طریق جستجوی تخصص پزشک مورد نظر و یا منطقه محل سکونت خود، از پزشکان و بیمارستان‌هایی که تمایل همکاری با پذیرش24 را داشته‌اند، نوبت دریافت کنید. چنانچه از طریق جستجو در وب‌سایت پذیرش24 موفق به دریافت نوبت از پزشک یا مرکز درمانی مورد نظر نشدید، در گوگل جهت بررسی اطلاعات صحیح از پزشک یا مرکز درمانی (نام و نام‌خانوادگی، تخصص، مطب و …) کمک گرفته و در نهایت چنانچه پزشک یا مرکز درمانی مورد نظر داخل سامانه پذیرش24 نبود، از طریق پشتیبانی اطلاع‌رسانی کنید تا در اسرع وقت همکاران پشتیبانی شما را راهنمایی کنند.',
      },
      {
        question: 'چگونه نوبت‌های ثبت‌شده را مشاهده کنم؟',
        answer:
          'از طریق پنل کاربری در وب‌سایت پذیرش24 یا از بخش «نوبت‌های من» در اپلیکیشن، نوبت‌های ثبت‌شده را می‌توانید مشاهده کنید.',
      },
      {
        question: 'آیا اطلاعات ثبت‌شده و نوبت‌ها در پذیرش ۲۴، برای دیگران نمایش داده می‌شود؟',
        answer:
          'خیر، این اطلاعات فقط در اختیار خود کاربر قرار می‌گیرد و تنها نوبت‌های ثبت‌شده به پزشک نمایش داده می‌شود.',
      },
      {
        question: 'آیا برای دیگران می‌توانید نوبت ثبت کنید؟',
        answer:
          'بله، شما می‌توانید با استفاده از بخش دریافت نوبت پس از انتخاب روز و زمان، بر روی گزینه «دریافت نوبت برای فرد دیگر» برای خانواده یا دوستان خود نیز نوبت ثبت کنید.',
      },
      {
        question: 'چرا هنگام دریافت نوبت با خطای «بازه غیرمجاز نوبت‌دهی» یا «مرخصی/تعطیلی پزشک» مواجه می‌شوید؟',
        answer:
          'با توجه به تنظیماتی که از سوی پزشک یا مراکز درمانی صورت می‌گیرد، ممکن است دریافت نوبت فقط در یک بازه زمانی مشخص مانند «از ساعت 8 الی 10 صبح» و یا فقط «روزهای شنبه» مقدور باشد. در این صورت، در پیغام خطا، ساعت دریافت نوبت بعدی برای شما نمایش داده می‌شود. همچنین از طریق اپلیکیشن می‌توانید از باز شدن نوبت‌دهی آتی پزشک مطلع شوید.',
      },
      {
        question: 'چگونه پزشک و یا تخصص مورد نظر را پیدا کنم؟',
        answer:
          'در صورت ثبت‌نام پزشک در پذیرش24، با جستجوی اسم پزشک (بدون غلط املایی و کامل) در وب‌سایت و اپلیکیشن می‌توانید به پزشک مورد نظر دسترسی پیدا کنید. برای جستجو داخل وب‌سایت و اپلیکیشن پذیرش24 شما می‌توانید با فیلتر کردن نام بیماری، تخصص پزشکان و یا مراکز درمانی به نتیجه مورد نیاز دست یابید.',
      },
      {
        question: 'نزدیکترین پزشک یا مرکز درمانی را چگونه پیدا کنم؟',
        answer:
          'با جستجوی تخصص مورد نیاز و مشخص کردن محل زندگی در سایت یا اپلیکیشن، سامانه پذیرش24 بر اساس اولویت‌بندی شما (انتخاب مواردی چون کمترین زمان معطلی، نزدیکترین نوبت و …) پزشک و مرکز درمانی را به شما پیشنهاد می‌دهد.',
      },
      {
        question: 'پزشکانی که تمایل به حضور در پلتفرم پذیرش 24 دارند، از چه طریقی می‌توانند ثبت‌نام کنند؟',
        answer:
          'درمانگران، منشی پزشکان و مراکز درمانی که به سامانه نوبت‌دهی آنلاین نیاز دارند، از طریق https://www.paziresh24.com/home/fordoctors/ می‌توانند درخواست خود را ثبت کنند تا کارشناسان ما در اسرع وقت درخواست را بررسی و پروفایل پزشک را فعال نمایند. در صورتی که دیگران را به پذیرش ۲۴ معرفی می‌کنید، همین روند نیز باید طی شود.',
      },
    ],
  },
  {
    id: 'online-visit',
    title: 'راهنمای دریافت ویزیت آنلاین',
    items: [
      {
        question: 'چگونه نوبت ویزیت آنلاین (واتساپ یا ایتا) را ثبت کنیم؟',
        answer:
          'پس از ورود به پذیرش24 (وب‌سایت یا اپلیکیشن) با مراجعه به قسمت ویزیت آنلاین پزشک، می‌توانید با انتخاب تخصص مورد نیاز خود، پزشکان ویزیت آنلاین را بر اساس ساعت ویزیت و آنلاین بودن انتخاب نموده و پس از طی کردن روند نوبت‌دهی و ثبت اطلاعات خود، نوبت خود را ثبت کنید.',
      },
      {
        question: 'چگونه مطمئن شویم نوبت ما ثبت شده است؟',
        answer:
          'پس از دریافت نوبت و پرداخت هزینه ویزیت آنلاین، کد پیگیری از طریق پیامک برای شما ارسال خواهد شد و اینگونه از ثبت شدن نوبت خود اطمینان حاصل می‌کنید.',
      },
      {
        question: 'نحوه ارتباط با پزشک در ویزیت آنلاین چگونه است؟',
        answer:
          'از طریق پیامک ثبت نوبت که برای شما ارسال شده، بر روی لینک واتساپ یا ایتا پزشک کلیک کرده و بعد از مشاهده قبض نوبت روی گزینه شروع گفت‌وگو با پزشک در واتساپ یا ایتا کلیک نمایید. وارد صفحه پزشک در واتساپ یا ایتا شوید و قبض نوبت شما به‌صورت پیش‌فرض در قسمت چت نوشته شده است. سپس گزینه ارسال را زده و منتظر باشید تا پزشک با شما ارتباط برقرار کند. ارتباط شما با پزشک در واتساپ یا ایتا متنی خواهد بود. لطفا بدون هماهنگی با پزشک از برقراری تماس تلفنی با پزشک خودداری کنید. توجه: برای ارتباط با پزشک از طریق لینک واتساپ یا ایتا، حتما از مرورگر کروم استفاده شود و در صورت روشن بودن فیلترشکن (VPN) آن را خاموش کنید.',
      },
      {
        question: 'اگر لینک شروع گفت‌وگو با پزشک، با خطا مواجه شد، چه روندی برای گفت‌وگو با پزشک باید طی شود؟',
        answer:
          'طبق راهنمایی که در قبض نوبت درج شده، شماره پزشک را ذخیره کنید و لینک قبض نوبت خود را کپی و در واتساپ یا ایتا برای پزشک ارسال نموده و با ایشان ارتباط بگیرید. لطفا بدون هماهنگی با پزشک از برقراری تماس تلفنی با پزشک خودداری کنید و فقط از طریق واتساپ یا ایتا با ایشان در ارتباط باشید.',
      },
      {
        question: 'در روش ویزیت آنلاین آیا امکان ارسال مستندات پزشکی بیمار وجود دارد؟',
        answer: 'بله، در صفحه گفت‌وگو با پزشک امکان ارسال مستندات پزشکی (عکس و فایل PDF) وجود دارد.',
      },
      {
        question: 'امکان تماس صوتی یا تصویری در ویزیت آنلاین وجود دارد؟',
        answer:
          'در ویزیت آنلاین (واتساپ یا ایتا)، ارتباط بین بیمار و پزشک به‌صورت متنی پیش خواهد رفت اما می‌توانید برای برقراری تماس با پزشک، در صفحه گفت‌وگو ابتدا هماهنگی‌های لازم را با پزشک بعمل آورید سپس در ساعت توافق‌شده به شکل صوتی یا تصویری و از طریق واتساپ با پزشک ارتباط برقرار کنید.',
      },
      {
        question: 'آیا ویزیت آنلاین به معنای ویزیت اورژانسی نیز می‌باشد؟',
        answer:
          'در نظر داشته باشید تمام تلاش تیم پذیرش24 بر این است که کاربر محترم بتواند با پزشک در لحظه ارتباط بگیرید اما گاهی امکان دارد به علت شرایط شغلی، پزشک در حالت اورژانسی (عمل جراحی، بیمار حضوری و …) باشد و در لحظه امکان پاسخگویی نباشد. بنابراین جهت دریافت پاسخ از پزشکان صبوری داشته باشید.',
      },
      {
        question: 'چگونه در ویزیت آنلاین نسخه خود را دریافت کنیم؟',
        answer:
          'در صورت صلاحدید، پزشکان می‌توانند به‌صورت الکترونیک و با استفاده از کد ملی شما نسخه مربوطه را ثبت کنند. کد نسخه از طریق پیامک برای شما ارسال می‌گردد. با مراجعه به داروخانه و اعلام کد ملی می‌توانید نسخه ثبت‌شده را دریافت کنید.',
      },
      {
        question: 'آیا در ویزیت آنلاین امکان لغو نوبت وجود دارد؟',
        answer:
          'جهت لغو نوبت در صورتی که هنوز زمان تقریبی نوبت شما فرا نرسیده است، می‌توانید با ورود به پنل کاربری (سایت یا اپلیکیشن) نوبت را لغو کنید. هزینه پرداختی به‌صورت خودکار بین 1 الی 72 ساعت کاری به حساب شما برگشت داده می‌شود. در صورتی که زمان نوبت گذشته باشد و به هر دلیلی قصد حذف آن را دارید با پشتیبانی پذیرش ۲۴ تماس حاصل فرمایید.',
      },
      {
        question: 'در صورتی که روند ویزیت آنلاین به طور کامل انجام نشود، چه اقدامی صورت می‌گیرد؟',
        answer:
          'مدت زمان اعتبار هر قبض، با توجه به تخصص پزشک، از زمان دریافت نوبت، بین 1 تا 3 روز می‌باشد. شما می‌توانید در این بازه با پزشک در ارتباط باشید تا پاسخ سوالات خود را دریافت کنید. همیشه جهت کسب اطلاعات دقیق‌تر قبض نوبت دریافتی خود را چک کنید. در صورتی که قبض نوبت شما منقضی شده باشد لازم است مجددا از پزشک نوبت دریافت کنید.',
      },
      {
        question: 'آیا می‌توانیم پرینت فاکتور نوبت را برای ارجاع به بیمه تکمیلی، دریافت کنیم؟',
        answer:
          'از طرف سامانه پذیرش24 فاکتور فیزیکی صادر نخواهد شد. در صورت لزوم شما می‌توانید از طریق مراجعه به پروفایل خود منوی «نوبت من ← قبض نوبت»، فاکتور را دریافت و برای مراجعه به بیمه استفاده نمایید.',
      },
      {
        question: 'چرا نوبت رزرو شده لغو می‌شود؟',
        answer:
          'دلیل اصلی لغو نوبت رزرو شده در سامانه، عدم حضور پزشک در مطب می‌باشد که لغو نوبت توسط پزشک یا منشی پزشک صورت می‌گیرد و پذیرش24 دخالتی در این روند ندارد.',
      },
      {
        question: 'مزیت ویزیت آنلاین نسبت به ویزیت حضوری چیست؟',
        answer:
          'گاهی دریافت یک مشاوره پزشکی تخصصی و به‌موقع، می‌تواند ضمن ارائه بینش درست در مواجهه با یک مساله، از صرف هزینه‌های غیرضروری برای آن جلوگیری کند. در بسیاری مواقع، نگرانی درباره یک عارضه یا بیماری و عدم دسترسی به یک مشاور مطمئن، باعث می‌شود که فرد، ضمن پرداخت حق ویزیت‌های سرسام‌آور برای مراجعه حضوری به پزشک، وارد فرایند دشوار و خسته‌کننده اخذ نوبت شود. فرایندی که گاهی ممکن است تا چند ماه هم به طول انجامد. پذیرش ۲۴ این امکان را فراهم کرده تا با رزرو اینترنتی نوبت و پرداخت هزینه مشاوره آنلاین، خیلی ساده به پاسخ این پرسش برسید که پیگیری مسئله‌ای که فکرتان را درگیر کرده، چقدر مهم است؟ آیا واقعاً نکته نگران‌کننده‌ای وجود دارد که پیگیری ماجرا و مراجعه حضوری به پزشک را ضروری کند؟ مشاوره آنلاین پزشکی به بهترین شکل به سوالاتی از این قبیل پاسخ می‌دهد.',
      },
      {
        question: 'برای چه مواردی باید با پشتیبانی ارتباط بگیرم؟',
        answer:
          'هرگونه سوال یا ابهامی که در سوالات پرتکرار این صفحه یافت نشد و یا با موردی خاص در روند ثبت نوبت مواجه شدید، می‌توانید با تیم پشتیبانی پذیرش ۲۴ ارتباط بگیرید.',
      },
    ],
  },
  {
    id: 'patients',
    title: 'سوالات بیماران در سامانه پذیرش24',
    items: [
      {
        question: 'چگونه می‌توان در سایت پذیرش24 نوبت گرفت؟',
        answer: 'با مطالعه راهنمای دریافت نوبت در وب‌سایت پذیرش۲۴ می‌توانید به‌راحتی نوبت دلخواه خود را ثبت کنید.',
      },
      {
        question: 'چطور آدرس (یا لوکیشن) مطب پزشک را پیدا کنم؟',
        answer:
          'با ورود به وب‌سایت یا اپلیکیشن پذیرش24، ابتدا نام پزشک مورد نظر را جستجو کرده و از طریق ورود به پروفایل پزشک به اطلاعاتی نظیر آدرس، لوکیشن، شماره تماس مطب و… دست پیدا کنید (اطلاعات آدرس و شماره تماس توسط منشی یا خود پزشک ثبت می‌گردد).',
      },
      {
        question: 'مبلغ بیعانه بیمار در ویزیت آنلاین در چه صورتی استرداد می‌شود؟',
        answer:
          'در صورتی که بیمار نوبت خود را تا 5 ساعت قبل از زمان ویزیت آنلاین، لغو کند؛ مبلغ بیعانه پس از 1 الی 72 ساعت به بیمار استرداد می‌شود.',
      },
      {
        question: 'استرداد هزینه چقدر زمان خواهد برد؟',
        answer:
          'درخواست استرداد هزینه بررسی و در صورت تایید، وجه پرداختی از 1 تا حداکثر 72 ساعت بعد از درخواست به حساب شما عودت داده خواهد شد. لطفا نسبت به بررسی گردش حساب بانکی خود در این بازه اقدام کنید.',
      },
      {
        question: 'چرا نظری که ثبت کرده‌ام نمایش داده نمی‌شود؟',
        answer:
          'این موضوع می‌تواند به دو دلیل باشد: ۱- نظر شما رد شده است (گاهی به دلیل ادبیات نامناسب و توهین‌آمیز، نظرات قابلیت نمایش ندارند). ۲- نظر شما در دست بررسی است.',
      },
      {
        question: 'چرا نوبت پزشک ثبت نمی‌شود؟',
        answer:
          'برای بررسی مشکلات احتمالی در ثبت نوبت، لطفا تصویر یا عبارت خطایی که دریافت می‌کنید را برای بخش پشتیبانی ارسال نمایید تا پاسخ سوالات شما در سریع‌ترین زمان و با دقت کافی داده شود.',
      },
      {
        question: 'نحوه تغییر زمان نوبت (جابجایی نوبت) به چه صورت امکان‌پذیر است؟',
        answer:
          'برای جابه‌جایی نوبت کافیست قبل از فرارسیدن زمان نوبت، وارد حساب کاربری خود در پذیرش ۲۴ شوید و از قسمت «نوبت‌های من ← جابجایی نوبت» زمان نوبت را تغییر دهید.',
      },
      {
        question: 'آیا می‌توانم به صورت تلفنی با پزشک صحبت کنم؟',
        answer:
          'امکان گفت‌وگوی تلفنی با پزشک در ویزیت آنلاین پذیرش ۲۴ وجود دارد. کافیست نام پزشک یا بیماری خود را در صفحه اول پذیرش ۲۴ و باکس جست‌و‌جو وارد کنید یا از طریق صفحه ویزیت آنلاین پذیرش ۲۴ اقدام به رزرو زمان گفت‌وگو با پزشک کنید.',
      },
      {
        question: 'نحوه تفسیر جواب آزمایش چگونه است؟',
        answer:
          'برای تفسیر جواب آزمایش می‌توانید از طریق صفحه مشاوره آنلاین پزشکی پذیرش ۲۴ از پزشکان نوبت دریافت نمایید و تصویر آزمایش خود را برای پزشک ارسال کنید و ویزیت شوید.',
      },
      {
        question: 'چگونه نوبت پزشکان شهر خاصی را مشاهده کنیم؟',
        answer:
          'کافیست در باکس جست‌و‌جوی پذیرش ۲۴، علامت لوکیشن (سمت چپ کادر) را انتخاب کنید تا لیست استان‌ها و شهرها برای شما نمایش داده شود. سپس پزشکان فعال در آن شهر مدنظر را می‌توانید ملاحظه کنید.',
      },
    ],
  },
  {
    id: 'doctors',
    title: 'سوالات پزشکان در سامانه پذیرش24',
    items: [
      {
        question: 'برای فعال‌سازی نوبت‌دهی چه اقدامی انجام دهیم؟',
        answer:
          'برای فعال کردن نوبت‌دهی در پذیرش ۲۴ نیاز است که در بخش پزشکان ثبت‌نام کنید. شماره موبایل (شماره باید حتما به نام پزشک باشد) را وارد نموده و سپس بر روی دکمه «ورود/ثبت‌نام» کلیک کرده و مراحل تکمیل پروفایل را ادامه دهید تا صفحه شما کامل گردد. توجه داشته باشید شماره‌ای برای ارتباط بیماران در پیام‌رسان‌هایی مانند واتساپ یا ایتا درج نمایید تا ارتباط بیماران ویزیت آنلاین با شما امکان‌پذیر باشد. با تعریف روز و ساعت کاری، نوبت‌دهی شما نهایتا تا ۷۲ ساعت کاری بعد از ثبت‌نام، برای ویزیت آنلاین شما فعال خواهد شد (در صورت زمانبر شدن این پروسه به بخش پشتیبانی اطلاع دهید).',
      },
      {
        question: 'نتوانستم تماس مربوط به مشاوره را پاسخ بدهم. چگونه تماس را مجددا برقرار کنیم؟',
        answer:
          'در صورت عدم پاسخگویی پزشک در زمان نوبت بیمار، تماس مجدد بعد از پنج دقیقه، مجدد برقرار خواهد شد. در صورت عدم پاسخگویی مجدد، نوبت با توجه به زمان‌های خالی پزشک جابه‌جا خواهد شد که تلاش می‌شود این نوبت به نزدیکترین فاصله ممکن منتقل شود. با توجه به گزارشات بیماران و نظرسنجی‌ها پیشنهاد می‌شود در صورتی که امکان پاسخگویی در ساعات مشخصی ندارید در ویزیت آنلاین آن ساعت‌ها را غیرفعال نمایید تا نارضایتی بیماران از شما کاهش یابد.',
      },
      {
        question:
          'نام بیمار در ویزیت آنلاینی که انجام شده اگر در پروفایل پزشک نمایش داده نشود و هزینه حساب نشده باشد، چه اقدامی باید صورت گیرد؟',
        answer:
          'دلیل حذف نوبت بیماران در ویزیت آنلاین، عدم رضایت آنها از خدمت دریافتی است. با توجه به ماهیت خدمات پزشکی و ارائه خدمات به‌صورت آنلاین، ممکن است در برخی موارد، مشکلات و مسائل مختلفی رخ دهد که باعث عدم رضایت بیماران شود. در این موارد، تلاش پذیرش ۲۴ برای رفع مشکلات و ارائه خدمات بهتر به بیماران است. در این صورت پس از بررسی مبلغ نیز به‌صورت خودکار به حساب بیمار استرداد خواهد شد.',
      },
      {
        question: 'نام بیماری که با او ویزیت آنلاین داشتم در پنل برای ثبت نسخه وجود ندارد.',
        answer:
          'به دلیل عدم ثبت اعلام مراجعه تا حداکثر ۱۵ دقیقه بعد از نوبت و لغو نوبت توسط کاربر، هزینه به کاربر استرداد و نوبت لغو شده است. ثبت اعلام مراجعه توسط پزشک برای جلوگیری از لغو اتوماتیک نوبت و برقراری مجدد تماس حائز اهمیت است.',
      },
      {
        question: 'اصلاح آدرس مطب یا اطلاعات پروفایل (شماره تلفن و …) به چه روشی امکان‌پذیر است؟',
        answer:
          'شما می‌توانید با ورود به بخش پروفایل پنل پزشکان پذیرش ۲۴، اطلاعات مورد نظر خود را ویرایش کنید. در صورتی که هنوز در پذیرش ۲۴ ثبت‌نام نکرده‌اید، می‌توانید از گزینه «من دکتر … هستم»، در صفحه پروفایل خود برای ثبت‌نام استفاده کنید.',
      },
      {
        question: 'نحوه ثبت مرخصی یا تغییر ساعت کاری در پنل پزشکان به چه صورت است؟',
        answer:
          'در صورتی که تمایل به اعمال مرخصی دارید از این مسیر استفاده کنید: پنل پزشکان پذیرش ۲۴ / تنظیمات نوبت‌دهی / اعمال مرخصی / انتخاب بازه مورد نظر / ذخیره تغییرات. می‌توانید از لینک http://p4z.ir/ecuzibv برای دسترسی مستقیم استفاده کنید. از بخش تنظیمات نوبت‌دهی می‌توانید موارد مرخصی، اعلام تأخیر و ساعت کاری خود را ویرایش کنید.',
      },
      {
        question: 'روند واریز هزینه ویزیت آنلاین به حساب پزشک چگونه می‌باشد؟',
        answer:
          'روش اول: برای درخواست تسویه حساب می‌توانید به قسمت تسویه حساب در پنل کاربری خود مراجعه کنید و درخواست تسویه کنید (پنل پزشکان پذیرش ۲۴ / پرداخت / گزارش مالی / درخواست تسویه حساب). این درخواست پس از تایید، در چرخه شبا، به حساب شما واریز خواهد شد. روش دوم: می‌توانید از طریق لینک http://p4z.ir/go6bjvv مستقیما به صفحه مورد نظر بروید.',
      },
      {
        question: 'چگونه مبلغ ویزیت آنلاین یا بیعانه را در صفحه پزشک تغییر دهیم؟',
        answer:
          'در صورتی که تمایل به تغییر مبلغ ویزیت یا بیعانه را دارید، از طریق «پنل پزشکان پذیرش ۲۴ / پرداخت / تنظیمات مالی / ویرایش مبلغ / ذخیره تغییرات» و یا به‌صورت مستقیم از لینک http://p4z.ir/ums788j اقدام نمایید.',
      },
      {
        question: 'مبلغ بیعانه بیمار در ویزیت آنلاین در چه صورتی استرداد می‌شود؟',
        answer:
          'در صورتی مبلغ بیعانه به بیمار استرداد می‌شود که بیمار نوبت دریافت‌شده را تا ۵ ساعت قبل از شروع زمان ویزیت آنلاین، لغو کند.',
      },
      {
        question: 'چرا نظرات بیماران من نمایش داده نمی‌شود؟',
        answer:
          'عدم انتشار نظرات کاربران دو دلیل عمده دارد: ۱- نظر کاربر رد شده است. ۲- نظر کاربر در دست بررسی است.',
      },
      {
        question: 'چگونه به عنوان پزشک در نتایج موتور جستجوی پذیرش۲۴ در رتبه‌بندی بهتر و بالاتر قرار بگیرم؟',
        answer: 'پارامترهای رتبه‌بندی پزشکان در لیست نتایج جستجو در راهنمای پذیرش۲۴ قابل مشاهده است.',
      },
      {
        question: 'می‌خواهم اطلاعات بیمارانی را که نوبت ثبت کردند مشاهده کنم. از چه طریقی امکان‌پذیر است؟',
        answer:
          'منشی پزشک از طریق شماره موبایلی که به نام پزشک است وارد سامانه پزشکان در پذیرش ۲۴ شده و لیست بیماران به همراه اطلاعات تکمیلی را در پنل مشاهده کنید. می‌توانید با تعریف رمز عبور ثابت برای پزشک، این فرآیند را تسهیل بخشید.',
      },
    ],
  },
];

export const faqPageTitle = 'سوالات متداول (FAQ)';
